if (window.innerWidth > 1024 || !/Mobi|Android/i.test(navigator.userAgent)) {
  document.body.classList.add("lock-scroll");

  let unlocked = false;

  function unlockScroll(reason) {
    if (!unlocked) {
      unlocked = true;
      document.body.classList.remove("lock-scroll");
      console.log("Scroll unlocked:", reason);
    }
  }

  // Unlock when page finishes loading
  window.addEventListener("load", function () {
    unlockScroll("on load");
  });

  // Or unlock after 3 seconds (whichever comes first)
  setTimeout(() => {
    unlockScroll("after 3 seconds");
  }, 3000);
}
